import type { FC } from 'react';
import { Button } from '@george-labs.com/design-system';

import { georgeStats } from '@shared/statistics';
import { t } from '@luna/i18n';

import type { HookParams } from './overview-appearance/useOverviewAppearanceChange';
import { useOverviewAppearanceChange } from './overview-appearance/useOverviewAppearanceChange';

type Props = HookParams & {
    hidden?: boolean;
};

export const PersonalizationCardOverviewAppearanceChange: FC<Props> = ({
    hidden,
    onChange,
    productType,
}) => {
    const { hideAccountOnOverview, showAccountOnOverview } = useOverviewAppearanceChange({
        onChange,
        productType,
    });

    if (hidden === undefined) {
        return null;
    }

    if (hidden) {
        return (
            <Button
                className="g-inverted"
                icon={Button.ICON.SHOW_ON}
                size={Button.SIZE.SMALL}
                data-cy="account-settings-personalise-show-on-overview-button"
                onClick={() => {
                    georgeStats.trackEvent('productSettings', 'showAccountOnOverviewIconClicked');
                    showAccountOnOverview();
                }}
            >
                {t('app.showOverview')}
            </Button>
        );
    }

    return (
        <Button
            className="g-inverted"
            icon={Button.ICON.SHOW_OFF}
            size={Button.SIZE.SMALL}
            data-cy="account-settings-personalise-hide-on-overview-button"
            onClick={() => {
                georgeStats.trackEvent('productSettings', 'hideAccountOnOverviewIconClicked');
                hideAccountOnOverview();
            }}
        >
            {t('app.hideOverview')}
        </Button>
    );
};
